{
  "COMMON": {
    "CATEGORIES": "Categories"
  },
  "INCIDENT_NOTICE": {
    "TITLE": "We never ask for your password or card details.",
    "BODY": "On 1 November some users received a fake notification. If you shared your details, change your password and read our guidance.",
    "READ_MORE": "Read more",
    "CLOSE": "Close"
  },
  "COMPONENTS": {
    "VERTICAL_LINK_BOX": {
      "HEADER_TITLE": "What are you looking for help with?",
      "HEADER_SUBTITLE": "Select a type of task"
    },
    "ACTIVITY": {
      "HEADER": "What's happening on Handyhand right now",
      "CLOSE": "Close window",
      "NEW_USER": "$$fullname$$ joined Handyhand",
      "NEW_HH": "$$fullname$$ created a profile",
      "NEW_TASK": "New task: \"$$taskname$$\"",
      "NEW_BID": "$$fullname$$ made a bid on \"$$taskname$$\"",
      "TASK_COMPLETED": "The task \"$$taskname$$\" has just been completed",
      "TASK_ACCEPTED": "A bid on \"$$taskname$$\" was accepted",
      "HH_UPDATED": "$$fullname$$ updated their profile!",
      "NEW_REVIEW": "$$fullname$$ received a 5-star review",
      "HH_VISITED": "$$fullname$$ checked out the task \"$$taskname$$\"",
      "OFFER_COMMENT": "$$fullname$$ commented on \"$$taskname$$\"",
      "TASK_COMMENT": "$$fullname$$ commented on \"$$taskname$$\"",
      "NEW_PAYMENT": "A bid was accepted",
      "VIEW_PROFILE": "View profile",
      "VIEW_TASK": "View task"
    },
    "CHANGELOG": {
      "TITLE": "Updates on the HandyHand platform",
      "SUBTITLE": "Stay updated on the latest improvements, important information, and new features for the HandyHand platform",
      "USER_SEGMENTS": "User types",
      "CATEGORIES": "Categories",
      "IMPORTANT": "Important",
      "DANISH": "Danish",
      "ENGLISH": "English",
      "SEARCH_PLACEHOLDER": "Search in changelog...",
      "CLEAR_FILTERS": "Clear all filters",
      "NO_RESULTS": "No results found",
      "CHANGE_FILTERS": "Try to change your filters to see more results"
    },
    "CHATBOT": {
      "WELCOME_TOOLTIP": "Hi! I can help with tasks, questions and price estimates. Just ask!",
      "HEADER_TITLE": "Handyhand Assistant",
      "INPUT_PLACEHOLDER": "Type your message here...",
      "CREATE_TASK_BUTTON": "Create task",
      "BACK_TO_CHAT": "Back to chat",
      "PRE_STEP_INTRO": "I can help you with:",
      "BACK_BUTTON": "Back",
      "BOT_NAME": "Handyhand Bot",
      "CREATE_TASK_NOW": "Create task",
      "GET_PRICE_ESTIMATE": "Get a price estimate",
      "IS_THIS_CORRECT": "Is this correct?",
      "CONFIRM_YES": "Yes",
      "CONFIRM_NO": "No",
      "CHECKING_FAQ": "Checking frequently asked questions...",
      "ERROR_START": "Sorry, I couldn't start the chat. Please try again later.",
      "ERROR_SEND": "<p class=\"error-message\">Sorry, something went wrong. Please try again.</p>",
      "MESSAGE_MARKERS": {
        "TASK_TITLE_COLON": "Task title:",
        "TASK_DESCRIPTION_COLON": "Task description:",
        "CONFIRM_TOKEN": "[[HH_CONFIRM]]"
      },
      "PRE_STEP_OPTIONS": {
        "PRICE": {
          "ID": "price",
          "TITLE": "Budget calculator",
          "DESCRIPTION": "Get a price estimate in seconds"
        },
        "HELP": {
          "ID": "help",
          "TITLE": "Chat",
          "DESCRIPTION": "Help with questions, budget and creation"
        },
        "TASK": {
          "ID": "task",
          "TITLE": "Create a task",
          "DESCRIPTION": "Create a task right away"
        }
      }
    },
    "HOW_IT_WORKS_DIALOG": {
      "TITLE": "How it works",
      "STEP_BY_STEP_TAB": "Step by step",
      "VIDEO_TAB": "Watch video",
      "MAIN_TITLE": "Create your task in a few minutes",
      "STEP_1": {
        "TITLE": "Describe your task",
        "DESCRIPTION": "Describe the task you want to get solved."
      },
      "STEP_2": {
        "TITLE": "Receive offers",
        "DESCRIPTION": "You typically receive the first offers within 5-10 minutes."
      },
      "STEP_3": {
        "TITLE": "Get your task solved",
        "DESCRIPTION": "The task is performed and you pay first, when you are satisfied."
      },
      "CREATE_TASK_BUTTON": "Create your first task now"
    },
    "BLOG": {
      "META_TITLE": "Handyhand Articles",
      "META_DESC": "Articles, Tips and tricks for the home, garden and DIY",
      "SNIPPET_FALLBACK": "Read more about this topic..."
    },
    "EARNING_AVERAGE": {
      "WEEK_TASKS": " tasks per week",
      "MONTH": "per month",
      "PRICE_AVG_1": "Based on average prices of",
      "PRICE_AVG_2": "tasks. Prices may vary"
    },
    "EARNINGS_CALCULATOR": {
      "META_TITLE": "Freelance Fee Calculator | Check Your Potential",
      "META_DESC": "Discover your potential earnings as a freelancer on Handyhand with our advanced fee calculator! By analyzing average wages from thousands of tasks on our platform, we ensure that you get a realistic estimate of what your income could be. Are you ready to be your own boss? Try the calculator and find out what your skills are worth on Denmark's leading service platform.",
      "TITLE": "Salary as a freelancer",
      "SUB_TITLE": "Calculate what your fee could be! With the calculator, you can get a realistic estimate of how much you can earn per week or per month!",
      "TXT_WRAPPER": "<p> With our freelance salary calculator, you can see how much money you can earn per month on Handyhand! If you have ever wondered how much you can earn by being, for example, a photographer or maybe pet sitting, you can find out here. This way you know what your skills are worth and how many tasks you need to complete to reach your financial goals. Every day tasks are created on Handyhand that you might have the skills to solve, so why not make money on what you are good at! You can decide for yourself whether it's part-time, full-time, or just occasionally when you feel like it. Create your user on our digital marketplace, bid on tasks, and start making money today!</p>",
      "TXT_CALC": "Our freelance salary calculator gives you the opportunity to find out the value of your skills",
      "TXT_1": "<h2>What can you use the calculator for?</h2><p> Many Danes experience that rising living costs affect their economy, and there is not as much money to live as they did before. With rising prices on housing loans, food, gasoline, and energy, there is less money left over each month. This means that most have to pay more to maintain their standard of living, and possibly need extra money to contribute to their income and keep up with everyday expenses. </p><p> Therefore, we have made a freelance fee calculator that you can use to better understand how you can earn some extra on your skills and abilities. Whether you have green fingers and are an expert in everything to do with gardening, or if you know exactly which cleaning products to use to remove any stain, there is a task for you on Handyhand. This new tool removes the guesswork, so you can better estimate your fee and earning potential and take control of your income and lifestyle. </p><p> Do you want to know how much you can earn? Choose from one of over 40 different categories, such as moving help, gardening, or cleaning, and then enter the following: </p><ul><li><p>Number of tasks per week</p></li><li><p>Frequency - weekly or monthly</p></li></ul><p> ...and voilà! The calculator uses the average task price based on our marketplace data. </p>",
      "USP_1": "Are you a born handyman?",
      "USP_2": "Use your skills and earn up to 35,000 per month with 5 tasks per week.",
      "EARN_UP": "Earn up to",
      "AMOUNT_28": "28,000",
      "AMOUNT_35": "35,000",
      "AMOUNT_38": "38,000",
      "MONTH": "Per month",
      "CLEAN_USP": "Are you sharp at cleaning?",
      "CLEAN_DESC": "Whether it's routine or final cleaning, you can make money on your cleaning skills and earn up to 28,000 DKK per month, if you perform 5 tasks per week.",
      "GREEN_USP": "Do you have green fingers?",
      "GREEN_DESC": "Do you love gardening, plants, or just being out in nature? Earn up to 38,000 DKK per month with 5 gardening tasks per week.",
      "CATEGORIES": {
        "ADMINISTRATION": "Administration",
        "AELDREHJAELP": "Elderly care",
        "BOERNEPASNING": "Childcare",
        "BROLAEGNING": "Paving",
        "BYGGE_PROJEKTER": "Building projects",
        "CHAUFFOER": "Chauffeur",
        "DIGITALT_DESIGN": "Digital design",
        "DYREPASNING": "Pet sitting",
        "ELEKTRIKER": "Electrician",
        "FLYTTEHJAELP": "Moving help",
        "FOTOGRAF": "Photographer",
        "FRISOER": "Hairdresser",
        "GULVARBEJDE": "Flooring",
        "HANDYMAN": "Handyman",
        "HAVEARBEJDE": "Gardening",
        "HJAELP_MOBIL_PC_TV": "Help with mobile, PC & TV",
        "INDRETNINGSARKITEKT": "Interior architect",
        "IVAERKSAETTERHJAELP": "Entrepreneur support",
        "LASESMED": "Locksmith",
        "MADLAVNING": "Cooking",
        "MALER": "Painter",
        "MASSOER": "Masseur",
        "MEKANIKER": "Mechanic",
        "MOEBEL_REPARATION": "Furniture repair",
        "MOEBELSAMSLING": "Furniture assembly",
        "MURER": "Bricklayer",
        "NEDRIVNING": "Demolition",
        "RENGOERING": "Cleaning",
        "REPARATION_BIL_BAAD_CYKEL": "Car, boat & bike repair",
        "RYDNING": "Clearance / waste pickup",
        "SANERING": "Remediation",
        "SERVERING_FESTHJAELP": "Serving or other party help",
        "SKADEDYRSBEKAEMPELSE": "Pest control",
        "SMED": "Blacksmith / metalwork",
        "SYNING": "Sewing",
        "TAGARBEJDE": "Roofing",
        "TEKSTFORFATTER": "Copywriter",
        "TOEMRER_SNEDKER": "Carpenter & joiner",
        "UNDERVISNING": "Teaching / tutoring",
        "VVS": "Plumbing"
      },
      "ENGINE": {
        "EARN": "How much can you earn?",
        "CHOOSE_CAT": "Choose a category / skill",
        "REQ_CAT": "You must choose a category / skill",
        "W": "With",
        "TASK_PR": "tasks per",
        "CALC_SALARY": "Calculate your salary",
        "EARN_POS": "You can earn",
        "START": "Get started now",
        "RESTART": "Restart the calculator",
        "CALC_1": "Based on average prices of",
        "CALC_2": "tasks. Prices may vary",
        "ERROR_FETCH_TASKS": "Could not load tasks. Please try again.",
        "ERROR_NO_PRICE_DATA": "No price data available for this category."
      }
    },
    "FAQ": {
      "Q1": "Relevant",
      "Q2": "questions",
      "Q3": "Questions and answers",
      "FULL": "FAQ - frequently asked questions"
    },
    "HANDYHANDER_LEVELS": {
      "TITLE": "How Handyhand levels work",
      "META_DESC": "Handyhand levels are designed to provide additional benefits to you as a task solver on Handyhand. When you earn a certain amount by completing tasks, you can reduce the service fee on future tasks with Handyhand levels.",
      "H1": "How Handyhand levels work",
      "H2": "How is my level calculated?",
      "H3": "What is my \"completion rate\"?",
      "H4": "What is my \"earnings\"?",
      "H5": "Where can I find more information?",
      "T1": "Handyhand levels are designed to provide additional benefits to you as a task solver on Handyhand. When you earn a certain amount by completing tasks, you can reduce the service fee on future tasks with Handyhand levels.",
      "T2": "You will be rewarded with different levels as you earn money by completing tasks on Handyhand. The levels are divided into bronze, silver, gold, and platinum. A higher level will result in a lower service fee on future tasks.",
      "T3": "Your level is determined by two different numbers:",
      "T4": "1. Your completion rate, i.e., how well you have been at completing the tasks you have been accepted for from your last 20 assigned tasks on the platform.",
      "T5": "2. Your earnings for the last 30 days, i.e., how much you have earned during the last 30 days.",
      "T6": "Each level has a minimum requirement for earnings and completion rate. You must meet these requirements to move to the corresponding level.",
      "T7": "Here are the fee rates for each level:",
      "T8": "Your completion rate reflects how well you have met your obligations to your last 20 assigned tasks.",
      "T9": "Completion rate is calculated by comparing all completed tasks with all canceled tasks in the last 20 assigned tasks. This way, there is a reasonable buffer included in case of unavoidable cancellations (It can happen!).",
      "T10": "A completion rate can currently fall into one of four levels: Poor, Okay, Good, and Fantastic. The more tasks you complete out of your last 20 assigned tasks, the better your completion rate.",
      "T11": "Your earnings score is based on your total earnings over the last 30 days.",
      "T12": "Each time a task owner releases payment to you, the amount is added to your total and will last for the next 30 days.",
      "T13": "You can find more information on how levels and fees work in this",
      "T14": "which also includes frequently asked questions. Feel free to contact support if you have feedback or suggestions.",
      "A_1": "article",
      "BRONZE": "Bronze",
      "FEE_LABEL": "{{fee}} service fee",
      "BRONZE_COM": "Poor completion rate on last 20 tasks",
      "BRONZE_EARN": "Earn less than 3,800 in the last 30 days",
      "SILVER": "Silver",
      "SILVER_COM": "Okay completion rate on last 20 tasks",
      "SILVER_EARN": "Earn more than 3,800 in the last 30 days",
      "GOLD": "Gold",
      "GOLD_COM": "Good completion rate on last 20 tasks",
      "GOLD_EARN": "Earn more than 11,500 in the last 30 days",
      "PLAT": "Platinum",
      "PLAT_COM": "Fantastic completion rate on last 20 tasks",
      "PLAT_EARN": "Earn more than 23,000 in the last 30 days"
    },
    "HERO": {
      "TITLE": "See what you can earn",
      "NEAR_Y": " near you",
      "NATIONAL_LINK": "{{service}} across Denmark",
      "NEEDS": "for all your needs",
      "FAST_CLEANING": "Ongoing cleaning?",
      "BOOKING_TEXT_2": "Get 100 kr for fast cleaning with HappyHelper with the code:",
      "BOOKING_TEXT": "Start here",
      "CODE_COPIED": "Code copied! You are being redirected now...",
      "BOOKING": "Booking",
      "ALT": {
        "EYEBROW": "Denmark's largest task platform",
        "TRUSTPILOT_EXCELLENT": "Excellent"
      }
    },
    "LINK_CONTAINER": {
      "IN": "in",
      "SERVICES_WORD": "services",
      "JOBS_WORD": "jobs",
      "OTHER": "Other",
      "OTHER_REGIONS": "Other regions",
      "PLACES": "and places",
      "RELATED_CITIES": "Related cities",
      "SERVICES": "Related services",
      "REL": "RELATED"
    },
    "PRICE_REVIEW": {
      "PARAGRAPH": "See all the reviews that people have given you.",
      "REPORT": "Report user",
      "LAT": "The latest ",
      "REV": "Latest reviews",
      "GET_PRICE": "Get a price"
    },
    "DAMAGE_COMPENSATION_LINE": {
      "TITLE": "Free damage compensation up to {{maxAmount}}",
      "LINK": "How it works"
    },
    "VALUE_LINE": {
      "SERVICE_COIN": "Cheaper than traditional providers",
      "SERVICE_TASK": "Small and large tasks",
      "SERVICE_DAMAGE_COMPENSATION": "Free damage compensation",
      "SERVICE_DAMAGE_COMPENSATION_DESC": "We offer free damage compensation covering up to {{maxAmount}} in damages, so you can book a Handyhand with peace of mind.",
      "SERVICE_PAY": "Secure cashless payment",
      "SERVICE_BOOKING": "Same or next day service"
    },
    "DEEP_LINK_BUTTONS": {
      "HOW_IT_WORKS": "How it works",
      "MEET_SOME_HANDYHANDS": "Who's helping",
      "EXAMPLES": "Examples",
      "FAQ": "FAQ",
      "PRICES_AND_REVIEWS": "Prices and reviews",
      "PRICES": "Prices",
      "REVIEWS": "Reviews",
      "GOOD_TO_KNOW": "Good to know",
      "WHY_HANDYHAND": "Why Handyhand",
      "POPULAR_ROUTES": "Popular routes"
    },
    "GLOBAL_SEARCH_ENGINE": {
      "PLACEHOLDER": "Search for categories, guides, articles, and much more.."
    },
    "FLOATING_CTA": {
      "BUTTON": "Get a price in 2 minutes"
    },
    "CHECKLIST": {
      "DONE_PERCENT": "Completed:",
      "SELECT_LABEL": "Select checklist:",
      "READ_MORE": "Read more",
      "SEE_GUIDE": "See guide:",
      "CREATE_TASK": "Create the task on Handyhand",
      "ADD_ITEM_PLACEHOLDER": "New item",
      "ADD_ITEM_DESC_PLACEHOLDER": "Description (optional)",
      "ADD_ITEM_BUTTON": "Add item",
      "EDIT_MODE_SAVE": "Save edits",
      "EDIT_MODE_EDIT": "Edit checklist",
      "PRINT_PDF": "Print PDF",
      "OPTIONS": {
        "WEDDING": "Wedding",
        "WEDDING_TODO": "Wedding checklist",
        "MOVING_OUT": "Moving out from home",
        "RENTAL_MOVE_IN": "Moving into a rental",
        "GARDEN": "Garden",
        "CLEANING_EQUIPMENT": "Cleaning supplies",
        "CLEANING_SCHEDULE": "Cleaning schedule",
        "AIRBNB_CLEANING": "Airbnb cleaning",
        "MOTORCYCLE_INSPECTION": "Motorcycle inspection"
      }
    },
    "CUSTOM_CARD": {
      "READ_PRICE_GUIDE": "Read the price guide",
      "SEE_ALL_PRICE_DATA": "See all price data guides"
    },
    "GENERIC_CARD": {
      "SEE_ALL_TIPS": "See all tips"
    },
    "SPONSORED_BANNERS": {
      "GO_TO_WEBSITE": "Go to website",
      "HEADER_PREFIX": "Sponsored"
    },
    "ASSOCIATED_TASKS": {
      "EXPAND_AREA_ARIA": "Expand section"
    },
    "HOW_IT_WORKS_VIDEO": {
      "IFRAME_TITLE": "How Handyhand works"
    }
  },
  "GENERAL": {
    "ABOUT_US": "About us",
    "AS_TO": "As a task owner",
    "BACK": "Back",
    "BEST": "The best",
    "COMPLETION_RATE": "Completion rate",
    "CREATE_TASK": "Create a task",
    "HELP": "Help",
    "HELP_FOR": "What do you need help with?",
    "HELP_FOR_TXT": "Do I need help with...",
    "HELP_NOW": "Find help now for free",
    "SEARCH_SITE_PLACEHOLDER": "Search our entire site...",
    "SEARCH_SUBMIT": "Search",
    "HEADER_SEARCH_PLACEHOLDER": "What are you looking for?",
    "CLEANING_ONE_OFF": "One-off cleaning",
    "CLEANING_SUBSCRIPTION": "Regular cleaning",
    "CLEANING_FIND": "Find cleaning",
    "DAMAGE_COMPENSATION": "Damage compensation",
    "TERMS": "Terms of service",
    "PRIVACY": "Privacy policy",
    "GUIDELINES": "Guidelines",
    "PRESS": "Press",
    "OFF_NOW": "Receive offers now for free",
    "SIMILAR_TASKS_BTN": "Create a similar task",
    "OFF": "Receive offers",
    "REQUEST_OFFER": "Request offer",
    "CREATE_FREE": "Create the task for free",
    "NO_TIME": "It takes less than 2 minutes and is free!",
    "FAQ": "FAQ - frequently asked questions",
    "REVIEW": "REVIEW",
    "SERVICE_IN_CAT": "Service providers within the category: ",
    "WHY_FLEX": "Flexibility",
    "PREV_TASK": "Previous tasks",
    "MEMBER": "Become a member",
    "OFFER_N": "What offers",
    "SEL_TASK_TYPE": "Select a type of task",
    "READ": "Read more",
    "INFO": "Info",
    "BEST_ASSOCIATED_USERS_SUB": "Handyhand is a marketplace with MitID verified helpers and genuine reviews – ready for your task",
    "TIME": {
      "WEEK": "week",
      "MONTH": "month"
    },
    "WITHIN_AREA": "solves tasks within \n the areas:",
    "WORTH_KNOW": "Worth knowing",
    "WHY_DESC": " Choose the tasks you want to perform for the people you are comfortable\n working with. You have control over your own calendar and can\n find the balance between work and private life that works\n for you.",
    "BTN": {
      "CATS": "Categories",
      "CAT_1": "Categories",
      "CREATE_TASK_NOW": "Create a task now",
      "SEE_ALL": "See all...",
      "SEE_MORE": "See more...",
      "FIND_TASKS": "View tasks",
      "BTN_TASK4": "Try it now"
    },
    "CONTROL": {
      "EXT": "Expand",
      "HIDE": "Hide"
    },
    "CUTS": {
      "EXPERT": ", from experts near you.",
      "HERE": "here",
      "FIND": "Find",
      "READ_MORE_ABOUT": "Read more about the subject",
      "FIND_A": "Find a",
      "HELP_WITH": "Help with",
      "FOR_TASK": " for the task",
      "NEAR_Y": " near you",
      "NOW": "now",
      "H_IN": "helps with gardening in",
      "HELP_FOR": "You can find help for",
      "IN": "and surrounding areas",
      "CREATE_TASK": "Create a task, receive offers and get the task done"
    },
    "CTA": {
      "HELP_TASK": "Do you want help to solve a task regarding",
      "HELP_OFFERED": " At Handyhand, private individuals offer affordable help to solve tasks, you can create your task here for free and let the handyhanders contact you with offers",
      "C_1": "It's ",
      "C_2": "free",
      "C_3": "and takes 2 minutes.",
      "SIGN_UP_NOW": "Sign up now"
    },
    "LOADING": {
      "CREATING_TASK": "Creating your task...",
      "REDIRECTING": "Redirecting to Handyhand..."
    }
  },
  "META": {
    "EARN": "Earn money with",
    "FIND_LOCAL": "Find local"
  },
  "NAVIGATION": {
    "BTN": {
      "CREATE_TASK": "Create task",
      "TRY_NOW": "Try it now",
      "CTA_START": "Get started now",
      "BACK_TO_PLATFORM": "Back to the platform"
    },
    "TXT": {
      "ABOUT_US": "About us",
      "CREATE_TASK": "Create a task",
      "HOME": "Home",
      "HOW_IT_WORKS": "How?",
      "LOGIN": "Login",
      "SIGN_UP": "Sign up",
      "SEE_TASKS": "View tasks",
      "SEE_ALL_TASKS": "View all tasks",
      "SEARCH_SITE": "Search the site",
      "SEARCH_PLACEHOLDER": "What do you need?"
    }
  },
  "PAGES": {
    "SECURITY_INCIDENT": {
      "META_TITLE": "Security notice: fake notifications on 1 November",
      "META_DESC": "On Sunday 1 November, a fake push notification was sent to some Handyhand users. Here's what happened and what you should do.",
      "EYEBROW": "Security",
      "TITLE": "Security notice: fake notifications on 1 November",
      "LEAD": "On Sunday 1 November at around 16:40, a fake push notification was sent to some of our users. Here's what happened and what you should do.",
      "STATUS_TITLE": "Status: contained and monitoring",
      "STATUS_BODY": "We have identified the root cause, removed the fake notifications, resolved it and added further safeguards. The platform is running normally and we are monitoring it closely. We have reported the incident to the police and the Danish Data Protection Agency (Datatilsynet).",
      "UPDATED": "Last updated: 3 November 2026",
      "WARNING_TITLE": "Never give out your payment or login details via a link or over the phone",
      "WARNING_BODY": "We never ask for your password or card details via a link or over the phone. Before you click a link or log in, check the web address carefully: it should say {{domain}}. If it looks even slightly different, don't click and don't enter anything.",
      "FAQ_TITLE": "Important information",
      "FAQ": {
        "ENTERED_DETAILS": {
          "QUESTION": "I clicked the link and input my information. What do I do?",
          "LOGIN": "If you input your log-in details, please change your password on {{domain}} now, and all other places you use this password. If you can't log in, use \"Forgot password\" on the login page.",
          "CARD": "If you input your card-details, please block your card, contact your bank and watch out for fraudulent charges.",
          "CHANGE_PASSWORD": "Change password"
        },
        "ONLY_CLICKED": {
          "QUESTION": "I clicked the notification/link, but didn't do anything else. Am I compromised?",
          "ANSWER": "If you clicked the link, but did NOT input log-in details or card-details, you are one of the affected users but your information is safe. You do not have to do anything."
        },
        "TASK_TODAY": {
          "QUESTION": "I have a task planned today - what do I do?",
          "ANSWER": "Handyhand is back online, so you can find the information about your task on the platform again. We apologize for the inconvenience while it was down.",
          "CALL_BEFORE": "If you still cannot get the relevant information, please contact support on",
          "CALL_AFTER": " and they will try to help faciliate contact between both parties. Please have patience."
        },
        "NOT_RECEIVED": {
          "QUESTION": "I didn't receive a notification or message, what now?",
          "ANSWER": "You are not affected and you do not have to do anything."
        },
        "SITE_NOT_WORKING": {
          "QUESTION": "The website/app still isn't working for me. Why?",
          "ANSWER": "Parts of Handyhand were temporarily taken offline as a security measure, and are back online now. If something still doesn't work, reload the page or log in again. If it keeps happening, contact support."
        },
        "WHICH_PARTS": {
          "QUESTION": "Which parts of the platform were affected?",
          "ANSWER": "The temporary shutdown affected profiles, tasks and messages. Everything is back online. We apologize for the inconvenience."
        },
        "ACCOUNT_BLOCKED": {
          "QUESTION": "Is my account blocked?",
          "ANSWER": "No, the message was not from us and your account is not blocked."
        }
      },
      "CTA_TITLE": "Do you have a task today?",
      "CTA_BODY": "If you still can't get the information you need, call support.",
      "CTA_BUTTON": "Call {{phone}}",
      "CLOSING": "For the safety of our users, we can't share more information right now. Thank you for understanding. We'll keep you updated."
    },
    "ABOUT_US": {
      "ABOUT_DESC": "In November 2018, Handyhand was founded. It started with two students, both needing an easy way to earn a little extra alongside their studies. Saxo, one of the founders, runs the company today, which consists of a team of enthusiasts who are passionate about the concept",
      "ABOUT_DESC_2": "The inspiration for the platform arose from Saxo's own father, who worked as a handyman and was always ready with a helping hand when tasks needed to be solved in or outside the home. He believed that everyone should have the opportunity to reach out to such a person. And thus, Handyhand came to life",
      "ABOUT_DESC_3": "Kind regards,",
      "CONTACT_US_TITLE": "Contact us",
      "CONTACT_US_DESC": "You are always welcome to send us an email at support@handyhand.dk or give us a call at 93 83 34 41 if you want to know more or need help.",
      "CHRIS": "Krisztian Szabo - Developer",
      "CHRIS1": "\"Our goal is to create as much value for society as possible\"",
      "HEADER_TITLE": "About Handyhand",
      "HEADER_SUB": "At Handyhand, we want to make it easier, cheaper, and safer to find help for everyday tasks in local communities.",
      "MEET_TEAM": "Team Handyhand",
      "PATRICK": "Patrick Sahlgren - CTO",
      "PATRICK1": "\"I love when I can make software that people can actually use\"",
      "SAXO": "Saxo Merrild - Founder",
      "SAXO1": "\"If we can give people more time and more money in their pocket, then we have won\"",
      "TITLE": "Who is Handyhand?",
      "BODY_TXT_1": "We are a digital platform that safely and easily connects you, born with 10 thumbs, with your local handyman. Community is one of our top priorities, and we make sure to be the safe link between you and the helpful souls.",
      "BODY_TXT_2": "Our platform ensures that sometimes overwhelming and time-consuming tasks land in the hands of someone who actually enjoys spending their Sunday cleaning, was born with a bit greener fingers than others, or just wants to earn some extra cash on handiwork.",
      "TITLE_2": "The platform",
      "BODY_TXT_3": "The idea of a digital gathering place for handymen can be traced back to Saxo's – the founder of Handyhand - own childhood, where he remembers his father rushing around on his bike with a tool belt around his waist to help wherever he could in the local community. He believed that everyone should have the opportunity for such personal service, which led to the establishment of Handyhand.",
      "BODY_TXT_4": "Over the past few years, tasks on Handyhand have evolved from primarily being craft-based to consisting of an endless variety of everyday chores; from clipping a pet's nails to assembling an IKEA cabinet. At Handyhand, there is room for everyone regardless of race, gender, nationality, profession, and skills, and only imagination sets the limits for what the next task should be.",
      "TIME_LINE_TITLE": "Timeline",
      "STAT_MEMBERS": "members",
      "STAT_PROVIDERS": "providers",
      "STAT_REVIEWS": "reviews",
      "USERS": "members",
      "ACQUIRED": "acquired",
      "TIME_LINE_SUBTITLE_1": "founded",
      "TIME_LINE_SUBTITLE_2": "launched",
      "TIME_LINE_SUBTITLE_3": "project",
      "TIME_LINE_1": "The company Pinploy is founded by Saxo and one of his then fellow computer science students",
      "TIME_LINE_DATE_1": "November, 2018",
      "TIME_LINE_TITLE_1": "Company Pinploy founded",
      "TIME_LINE_2": "The service platform Pinploy is launched as a website - pinploy.dk",
      "TIME_LINE_DATE_2": "April, 2020",
      "TIME_LINE_TITLE_2": "Website launched",
      "TIME_LINE_3": "The two founders go full-time and dedicate all their time to developing the platform",
      "TIME_LINE_DATE_3": "August, 2021",
      "TIME_LINE_TITLE_3": "Full-time on the project",
      "TIME_LINE_4": "With help from Krisztian, an accompanying iOS and Android App is launched",
      "TIME_LINE_DATE_4": "August, 2021",
      "TIME_LINE_TITLE_4": "iOS and Android APP",
      "TIME_LINE_6": "Pinploy absorbs Handyhand, the largest handyman platform in Denmark, and also adopts the name, Handyhand",
      "TIME_LINE_DATE_6": "August, 2022",
      "TIME_LINE_TITLE_6": "Pinploy becomes Handyhand",
      "TIME_LINE_7": "Handyhand surpasses 50,000 registered users on the platform",
      "TIME_LINE_DATE_7": "September, 2019",
      "TIME_LINE_8": "Handyhand reaches 100,000 users - a major milestone for the platform",
      "TIME_LINE_DATE_8": "July, 2022",
      "TIME_LINE_9": "Handyhand surpasses 150,000 users and is now available to everyone throughout Denmark",
      "TIME_LINE_DATE_9": "August, 2023",
      "TIME_LINE_10": "A respected Danish platform for cleaning services, connecting customers with trusted, independent cleaners. Acquired in April 2024 to strengthen both platforms while maintaining their distinct identities.",
      "TIME_LINE_DATE_10": "April, 2024",
      "TIME_LINE_TITLE_10": "Happy Helper Acquired",
      "TIME_LINE_11": "Handyhand surpasses 200,000 users across the platform",
      "TIME_LINE_DATE_11": "May, 2024",
      "TIME_LINE_12": "Handyhand surpasses 300,000 users and continues its strong growth trajectory",
      "TIME_LINE_DATE_12": "June, 2025",
      "TIME_LINE_13": "A platform acquired in November 2025, expanding Saxo Agdestein's portfolio in the marketplace and service industries.",
      "TIME_LINE_DATE_13": "November, 2025",
      "TIME_LINE_TITLE_13": "Shouter Acquired",
      "TIME_LINE_14": "Handyhand surpasses half a million users - a historic milestone for the platform",
      "TIME_LINE_DATE_14": "January, 2026",
      "TIME_LINE_SUBTITLE_REBRAND": "Rebrand",
      "TIME_LINE_SUBTITLE_APP": "App",
      "TIME_LINE_CARD_TITLE_APP": "iOS & Android",
      "TIME_LINE_MILESTONE_500K_PLUS": "500K+",
      "TIME_LINE_MILESTONE_300K": "300K",
      "TIME_LINE_MILESTONE_200K": "200K",
      "TIME_LINE_MILESTONE_150K": "150K",
      "TIME_LINE_MILESTONE_100K": "100K",
      "TIME_LINE_MILESTONE_50K": "50K",
      "TIME_LINE_LOGO_ALT_SUFFIX": "logo",
      "MEDIA_TITLE": "Handyhand in the media",
      "MEET_TEAM_TITLE": "Meet the team",
      "MEET_TITLE": "Meet the team",
      "MASCOT_TITLE": "Meet Kuno - Handyhand's Mascot",
      "HOW_IT_WORKS_TITLE": "How it works",
      "HOW_STEP_1_TITLE": "Post a task",
      "HOW_STEP_1_DESC": "Describe your task and receive offers from qualified helpers in your local area.",
      "HOW_STEP_2_TITLE": "Choose your helper",
      "HOW_STEP_2_DESC": "Compare offers, read reviews and choose the helper that best fits the job.",
      "HOW_STEP_3_TITLE": "Job done",
      "HOW_STEP_3_DESC": "Your helper completes the task. Pay securely through the platform when you're satisfied.",
      "MISSION_TITLE": "Our values",
      "VALUE_1_TITLE": "Safety",
      "VALUE_1_DESC": "All users are verified with MitID. We ensure a safe environment for both task owners and helpers.",
      "VALUE_2_TITLE": "Community",
      "VALUE_2_DESC": "We connect people in local communities and create opportunities for everyone.",
      "VALUE_3_TITLE": "Fair pay",
      "VALUE_3_DESC": "Helpers set their own prices. No hidden fees, transparent terms.",
      "VALUE_4_TITLE": "For everyone",
      "VALUE_4_DESC": "Whether you need a hedge trimmed or a cabinet assembled — there's room for all tasks.",
      "WHY_TITLE": "Why Handyhand?",
      "WHY_1": "Denmark's largest platform for everyday help with over {{users}} members",
      "WHY_2": "All helpers and task owners are verified with MitID for your safety",
      "WHY_3": "Secure payment through the platform — you only pay when the task is completed",
      "WHY_4": "Free to post tasks — you only pay when you accept an offer",
      "WHY_5": "Over 20,000 reviews on Trustpilot with an average of 4.5 stars",
      "GROWTH_TITLE": "Our impact",
      "GROWTH_TASKS": "tasks created",
      "GROWTH_PAID": "paid to helpers",
      "GROWTH_COVERAGE_VALUE": "All of DK",
      "GROWTH_COVERAGE": "nationwide",
      "TRUSTPILOT_DESC": "Based on over 5,000 reviews on Trustpilot",
      "PARTNERS_TITLE": "Trusted partners",
      "META_TITLE": "About the team behind Handyhand",
      "META_DESC": "Who are we and why did we start Handyhand? Get answers here"
    },
    "APP_LANDING": {
      "META_TITLE": "Handyhand App for iOS and Android - Download",
      "META_DESC": "Earn money by performing tasks at home with the app on our platform - Share tasks you'd like to have done, bid on tasks and get updated about your tasks directly on your phone",
      "TITLE": "Never",
      "TITLE_1": "miss out on",
      "TITLE_2": "anything",
      "UPDATE_CONTENT": "Create tasks you need to get done, make bids and stay updated, even when you're on the go.",
      "ON_THE_GO": "Get to know the app",
      "POST_BROWSE_TASKS_HEADLINE": "Create or find tasks",
      "POST_BROWSE_TASKS_CONTENT": "Create tasks you need help with, or bid on tasks you wish to perform.",
      "COMMUNICATION_HEADLINE": "Easy to communicate with others",
      "COMMUNICATION_CONTENT": "When you accept a bid from a Handyhand, or are chosen to perform a task, it's possible to communicate directly through private messages.",
      "PAYMENTS_HEADLINE": "Quick and secure payment",
      "PAYMENTS_CONTENT": "Through our secure payment system, you or your Handyhand will be paid for the work done.",
      "DOWNLOAD_NOW": "Download the app now",
      "MOCKUPS": {
        "TASK_NEW": {
          "HEADER": "New task",
          "HERO_SUB": "Today is a great day to get tasks done!",
          "HERO_TITLE": "What task do you need done?",
          "QUESTION_WHAT": "What do you need help with?",
          "EXAMPLE_INPUT": "e.g. paint a room",
          "QUESTION_WHEN": "When should it be done?",
          "PILL_SPECIFIC_DATE": "Specific date",
          "PILL_BEFORE_DATE": "Before date",
          "PILL_FLEXIBLE": "Flexible",
          "TOGGLE_TIMESLOT": "A specific time slot is required",
          "NEXT_BUTTON": "Next"
        },
        "TASK_INPUT": {
          "QUESTION_WHAT": "What do you need help with?",
          "EXAMPLE_INPUT": "Help moving a sofa",
          "QUESTION_WHEN": "When?",
          "PILL_ON_DATE": "On date",
          "PILL_BEFORE_DATE": "Before date",
          "PILL_FLEXIBLE": "Flexible"
        },
        "CHAT": {
          "NAME_1": "Lars",
          "NAME_2": "Jens",
          "INITIAL_1": "L",
          "INITIAL_2": "J",
          "MSG_1": "Hi Lars, we've cleared a path so you can carry the sofa in through the front door – should make it a bit easier",
          "MSG_2": "Hi Jens, awesome, that definitely makes it easier. We'll be there at 8:30!"
        },
        "PAYMENT": {
          "HEADER": "Payment",
          "STATUS": "Payment sent",
          "AMOUNT": "500 kr",
          "LABEL": "To the Handyhand",
          "RECEIPT_DATE": "Today · 09:41"
        }
      }
    },
    "BLOG": {
      "TITLE": "Handyhand Articles",
      "DESC": "Articles, Tips and tricks for the home, garden, and DIY."
    },
    "CREATE_TASK": {
      "STEPS_BUDGET_GENERATOR": {
        "TITLE": "Budget estimate",
        "ELAB_QUESTIONS": "Elaborating questions",
        "SUB_V1": "Based on over {{tasks}} tasks, we have prepared an estimate for your project. Receive various offers and choose the best one. The final price is determined once you have selected an offer. There is no obligation to accept.",
        "FAILED": "An error occurred while calculating your budget. Please try entering a more detailed task description or choose a budget yourself.",
        "CALCULATING_BUDGET": "Calculating budget",
        "CALCULATING_BUDGET_DESCRIPTION": "Estimating a budget for your task based on over {{tasks}} other tasks. Please wait...",
        "LOW": "Low",
        "AVG": "Average",
        "HIGH": "High",
        "AI_WELCOME": "Hey, I am Handyhands AI-BudgetEstimation Tool..",
        "DESC": "Description",
        "BUDGET": "Budget",
        "SUB_TASKS": "Sub Tasks",
        "EXPLAIN": "Explanation",
        "YOUR_ESTIMATE": "Your budget estimate",
        "YOUR_ESTIMATE_DESC": "You can change the budget if you are not satisfied with the estimate",
        "FAILED_PREDICT": "Failed to estimate budget from task description. Please enter budget manually",
        "FINISHING_UP": "Finishing up please wait, it can take up to 30 seconds",
        "CREATE_TASK": "Create task",
        "CREATE_TASK_TIP": "*You can edit the details after you have clicked on 'Create task'",
        "LOADING_STEPS": {
          "LOADING": {
            "ANALYZING_TASK_TYPE": "Analyzing the type of task...",
            "ESTIMATING_TASK_SCOPE": "Estimating the scope of the task...",
            "COMPARING_TASKS": "Comparing with {{tasks}}+ tasks...",
            "FINDING_PRICES_RUNNING_TASKS": "Finding prices for ongoing tasks...",
            "ESTIMATING_BUDGET_TASK": "Estimating the budget for your task..."
          },
          "COMPLETED": {
            "ANALYZING_TASK_TYPE": "Task is analyzed",
            "ESTIMATING_TASK_SCOPE": "The scope of the task is estimated",
            "COMPARING_TASKS": "{{tasks}}+ tasks compared",
            "FINDING_PRICES_RUNNING_TASKS": "Current tasks found",
            "ESTIMATING_BUDGET_TASK": "Budget estimate calculated"
          }
        },
        "CERTAINTY_SCORE": {
          "TITLE": "Budget accuracy",
          "LOW": "LOW",
          "MEDIUM": "MEDIUM",
          "HIGH": "HIGH"
        },
        "FAQ": "Frequently Asked Questions",
        "FAQ_1": "How does the budget calculator work?",
        "FAQ_1_1": "We use artificial intelligence to accurately estimate a budget for your project. By comparing your project with over {{tasks}} similar tasks, our advanced algorithms utilize data to determine pricing. We consider the scope of the project to develop a tailored budget based on this information.",
        "FAQ_2": "How is my budget calculated?",
        "FAQ_2_1": "[INSERT BUDGET CALCULATION EXPLANATION HERE]",
        "FAQ_3": "Why does my task need a budget?",
        "FAQ_3_1": "A budget helps Handyhanders understand what you expect to pay for the task. It also helps ensure you receive realistic bids for the task.",
        "FAQ_4": "What if I don't agree with the budget?",
        "FAQ_4_1": "You can always change the budget if you do not agree with it. You can also choose to enter your own budget.",
        "FAQ_SIMILAR_1": "Similar tasks from others ",
        "FAQ_SIMILAR_2": "and",
        "FAQ_SIMILAR_3": "See some examples of tasks others have posted and what offers they got",
        "SIMILAR_TASKS": {
          "DESC": "Description",
          "PRICE": "Average offer on task",
          "PRICE_TOOLTIP": "The average offer across all offers given on this task",
          "TIME": "Average hours to complete task",
          "TASK_OWNER": "Posted by",
          "HOURS": "hours",
          "HOUR": "hour",
          "NUMBER_OF_OFFERS": "Number of offers on task",
          "MATCH_DEGREE": "Match degree",
          "MATCH_TOOLTIP": "The match degree is based on the similarity to your task."
        }
      }
    },
    "HH_LANDING": {
      "BASED_ON": "Based on",
      "BECOME": "Become a Handyhander",
      "JOB_CATEGORIES_TITLE": "Find jobs by category",
      "JOB_CATEGORIES_DESC": "Browse the task types where work comes up most often, and get started where your skills fit best.",
      "EARN": "Earn money",
      "HEADER_TITLE": "Be your own boss",
      "HEADER_TITLE_1": "Earn up to 35,000 kr per month on Handyhand",
      "HEADER_DESC": "How can one earn some extra or quick money? The answer is Handyhand.dk. If you want to find work and earn money online, then Handyhand is the right place for you. With our online website/platform, you can quickly find work tasks that suit you.",
      "HEADER_CTA_TEXT": "Create. choose, done.",
      "HEADER_CTA_PRIMARY_BUTTON": "Get started now",
      "HEADER_CTA_SECONDARY_BUTTON": "View tasks",
      "HOW_IT_WORKS_FIND_TITLE": "Find a task",
      "HOW_IT_WORKS_FIND_DESC": "Find a task that you would like to perform and make a bid",
      "HOW_IT_WORKS_CREATE_TITLE": "Create your profile",
      "HOW_IT_WORKS_CREATE_DESC": "Create a profile on Handyhand for free",
      "HOW_IT_WORKS_DO_TITLE": "Complete the task and get paid",
      "HOW_IT_WORKS_DO_DESC": "Complete the task and receive payment and a review",
      "FEATURE_SECTION_TITLE": "Why should I use Handyhand?",
      "FEAT_1": "Secure payment",
      "FEAT_2": "HandyhandPay ensures that you are always paid for your work without the risk of being cheated or having to collect yourself.",
      "FEAT_3": "Improve your reputation",
      "FEAT_4": "With Handyhand, you get a profile where you can earn badges, stars, reviews, and more, which you can showcase or link to.",
      "FEAT_5": "Easy and fast",
      "FEAT_6": "You can quickly and easily find work near you. The platform provides an easy and quick overview of available tasks near you.",
      "META_TITLE": "Become Handyhand | Find jobs | Small jobs | Work | Part-time work | Handyhand™",
      "META_DESC": "✅ Earn money with Handyhand. ✅ Denmark's best marketplace for jobs & tasks. ✅ Everything from handymen to Cleaning. ✅ Find work now and earn money online.",
      "PLATFORM_RIGHT_TITLE": "Find task opportunities for free",
      "PLATFORM_RIGHT_DESC": "Become a Handyhander and start earning money right away. Get notifications in our app every time there is a task that matches your skills and interests.",
      "PLATFORM_TASK_TITLE": "Set your price",
      "PLATFORM_TASK_DESC": "Found a task that's just right for you? Set your price and send an offer. You can adjust and discuss the offer with the customer later.",
      "PLATFORM_COMM_TITLE": "Complete the task, get payment - it's that simple",
      "PLATFORM_COMM_DESC": "When you indicate that a task is completed, a request for payment is automatically sent and as soon as the task setter approves, the money will be released in the system.",
      "TESTOMONIALS_TITLE": "Other Handyhands",
      "WHY_HANDYHAND_TITLE": "Create your profile and find tasks today",
      "WHY_HANDYHAND_DESC1": "It takes a few minutes to create a profile and then you can start finding your first task",
      "WHY_HH_TITLE": "Earn extra money with Handyhand",
      "WHY_HH_DESC1": "Earn quickly and easily with Handyhand.dk! Whether you're a handyman, craftsman, tutor, or cleaning assistant, find flexible jobs that suit you.",
      "WHY_HH_DESC2": "Our platform connects you with work tasks - some Handyhanders earn over 35,000 per month!",
      "WHY_HH_DESC3": "The platform is perfect for professionals, students, or retirees seeking extra income. Take control of your time and earnings with Handyhand!",
      "WHY_HH_CTA_TEXT": "Ready to become part of the community?",
      "WHY_HH_BUTTON": "Become a Handyhander",
      "USP_1": "Earn up to 35,000 kr per month",
      "USP_2": "Quick to get started - earn money from day one",
      "USP_3": "Automatically covered by damage compensation",
      "USP_4": "Use our app to manage everything",
      "USP_5": "You decide which jobs you want to take - and how often",
      "QUESTION_1": "Ready to be your own boss?",
      "QUESTION_2": "Whether you are a handyman, cleaning expert, or can offer a completely different service, Handyhand is the sharing economy platform where you can locally post tasks or find jobs. Handyhand makes it easy to find small or medium-sized jobs online through our platform. Help people get tasks done in their homes and earn money today on small tasks."
    },
    "HOW_IT_WORKS": {
      "HERO": {
        "REVIEWS": "Reviews",
        "TASK_COMPLETED": "Task completed",
        "TASK_PAID": "Payment sent",
        "TIME_2_MIN_AGO": "2 min ago",
        "TIME_1_MIN_AGO": "1 min ago"
      },
      "MOCKUPS": {
        "TITLE_DUEDATE": {
          "QUESTION_WHAT": "What do you need done?",
          "EXAMPLE_INPUT": "Help moving a sofa",
          "QUESTION_WHEN": "When?",
          "PILL_ON_DATE": "On date",
          "PILL_BEFORE_DATE": "Before date",
          "PILL_FLEXIBLE": "Flexible"
        },
        "LOCATION": {
          "QUESTION_WHERE": "Where is the task?",
          "OPTION_IN_PERSON": "On-site",
          "OPTION_ONLINE": "Online"
        },
        "DESCRIPTION": {
          "TITLE": "Description",
          "EXAMPLE_TEXT": "I've bought a new sofa delivered to the curb but need help carrying it up to the 3rd floor",
          "ADD_IMAGES_LABEL": "Add pictures"
        },
        "BUDGET": {
          "QUESTION_BUDGET": "What is your budget?",
          "EXAMPLE_AMOUNT": "500 kr"
        },
        "GET_OFFERS": {
          "NEW_OFFERS_BADGE": "5 new offers received",
          "ACCEPT": "Accept",
          "NAME_1": "Maria",
          "NAME_2": "John",
          "NAME_3": "Frank",
          "NAME_4": "Sam"
        }
      },
      "STEPS": {
        "TITLE_DUEDATE_STEP_TITLE": "State what you need done and by when",
        "TITLE_DUEDATE_STEP_DESC": "Briefly describe what you would like done and indicate when you want the task to be carried out",
        "LOCATION_STEP_TITLE": "Where should the task be carried out?",
        "LOCATION_STEP_DESC": "Indicate where the task should be carried out. For example, does it require someone on-site or can it be solved online via a video meeting?",
        "DESCRIPTION_STEP_TITLE": "Briefly describe what the task involves",
        "DESCRIPTION_STEP_DESC": "The description helps our Handyhanders assess the task so you get the best possible offer.",
        "BUDGET_STEP_TITLE": "Choose your budget",
        "BUDGET_STEP_DESC": "This is only a rough estimate - you can negotiate the final price later.",
        "GET_OFFERS_STEP_TITLE": "Receive offers and choose the best person to carry out the task",
        "GET_OFFERS_STEP_DESC": "Look at profiles and reviews and decide for yourself who you think best fits the task."
      },
      "TITLE": "Create your first task in a few minutes",
      "CREATE_TASK": "Create your task, choose a person, get it done",
      "COMMUNICATION_TITLE_1": "Easy to communicate",
      "COMMUNICATION_CONTENT_1": "Once you have accepted a bid, you can make direct contact with your Handyhand through private messages. Together, you can agree on details and keep in touch until the task is resolved.",
      "CLOSE": "Close",
      "DESC_CONTENT_1": "With hundreds of tasks on the platform each month, there is a great opportunity to perform tasks and earn money. Choose the tasks that best suit you and your skills.",
      "DESC_CONTENT_2": "With Handyhand's secure payment system, you can be sure to receive your payment when the task is completed.",
      "DESC_SUBTITLE_3": "Strong damage compensation",
      "DESC_CONTENT_3": "With the our strong damage compensation model you can safely perform tasks through Handyhand. Read more about our damage compensation ",
      "HEADLINE": "How does it work?",
      "LIGHTBOX_BUTTON": "Videoinstruction",
      "META_TITLE": "How it works ",
      "META_DESC": "Get access to thousands of skilled people for tasks in all categories. Everything from assembling furniture to data communication - hire a skilled Handyhander today.",
      "PAY_TITLE": "HandyhandPay™",
      "PAY_CONTENT_1": "With HandyhandPay™ you can easily and securely pay your Handyhand when you get a task done through Handyhand. Our payment system holds the amount until the task is completed.",
      "PAY_CONTENT_2": "Only when the task is reported as completed, the money is paid out to your Handyhand. In the event that the task is not performed, the money will of course be refunded to your account.",
      "PAY_ICON_1": "Fast and secure",
      "PAY_ICON_2": "Cash-free",
      "PAY_ICON_3": "You are in control",
      "SUB_HEADER_1": "What do you need to get done?",
      "SUB_HEADER_2": "Choose the right person for the task",
      "SUB_HEADER_3": "Task completed",
      "SUB_TEXT_1": "Start by telling us about your task. Describe when and where you need it done, and then suggest a reasonable budget for the task. You can share any kind of task, everything from cleaning to web design in just two minutes - and for free! There is 100% non-binding and free to get started.",
      "SUB_TEXT_2": "Take a look at profiles and reviews to choose the best Handyhand for your task. Once you accept a bid, your payment is securely held with HandyhandPay until the task is completed and you are satisfied. Now you can send messages and call your Handyhand to get the details in place.",
      "SUB_TEXT_3": "Once your task is completed, simply release the payment then held with HandyhandPay. Now you can write a review of the Handyhand's work, so everyone can see the good job he/she has done!",
      "SUB_HEAD_TEXT": "Save yourself the hassle and get through your to-do list today",
      "HEADER": "All everyday tasks gathered on one platform",
      "HH_DESC": "Earn money with Handyhand",
      "HH_BOSS": "Be your own boss",
      "HERE": "here.",
      "SAFE_PAY": "Secure payment",
      "DOWNLOAD_APP_TITLE": "Stay updated",
      "DOWNLOAD_APP_CONTENT_1": "With Handyhand's app, you can stay updated even when you're on the go. You can create tasks, review bids, or communicate with your Handyhand. You can also bid on other people's tasks and keep an eye on whether your bids are accepted.",
      "REVIEWS_TITLE": "Ratings & reviews",
      "REVIEWS_CONTENT_1": "The platform allows you to view profiles and read reviews of our Handyhanders. This way, you get the best prerequisites for choosing the right person for the task.",
      "STEP_1": "Describe your task",
      "STEP_2": "Receive bids",
      "STEP_3": "Get your task done",
      "TASKS": {
        "FURNITURE_ASSEMBLY": {
          "TITLE": "Furniture Assembly",
          "DESCRIPTION": "Help with assembling Ikea wardrobe"
        },
        "PAINTING": {
          "TITLE": "Painter",
          "DESCRIPTION": "Preparation of apartment for moving inspection"
        },
        "MOVING_ASSISTANCE": {
          "TITLE": "Moving Assistance",
          "DESCRIPTION": "Moving a 150 sqm house to Roskilde from Copenhagen"
        },
        "GARDENING": {
          "TITLE": "Gardening",
          "DESCRIPTION": "Pruning of 4 larger trees"
        },
        "IT_SUPPORT": {
          "TITLE": "IT Support",
          "DESCRIPTION": "Reinstallation of Windows + programs"
        },
        "ELECTRICIAN": {
          "TITLE": "Electrician",
          "DESCRIPTION": "Installation of Sonos music system in house"
        },
        "CLEANING": {
          "TITLE": "Cleaning",
          "DESCRIPTION": "Weekly cleaning of apartment (114 sqm)"
        },
        "MOVING_ASSISTANCE_2": {
          "TITLE": "Moving Assistance",
          "DESCRIPTION": "Moving a 150 sqm house to Roskilde from Copenhagen"
        },
        "ELECTRICIAN_2": {
          "TITLE": "Electrician",
          "DESCRIPTION": "Setting up lamps in living room and bedroom"
        },
        "CATERING": {
          "TITLE": "Catering",
          "DESCRIPTION": "3-course menu for 14 people"
        },
        "PLUMBING": {
          "TITLE": "Plumbing",
          "DESCRIPTION": "Fix leaking bathroom sink and replace faucet"
        },
        "CARPENTRY": {
          "TITLE": "Carpentry",
          "DESCRIPTION": "Build custom bookshelf for living room"
        },
        "DOG_WALKING": {
          "TITLE": "Dog Walking",
          "DESCRIPTION": "Daily walks for a medium-sized dog for one week"
        },
        "PHOTOGRAPHY": {
          "TITLE": "Photography",
          "DESCRIPTION": "Professional family photoshoot in local park"
        },
        "WEB_DESIGN": {
          "TITLE": "Web Design",
          "DESCRIPTION": "Create a simple portfolio website for a small business"
        },
        "TUTORING": {
          "TITLE": "Tutoring",
          "DESCRIPTION": "Math tutoring for high school student, 5 sessions"
        },
        "WINDOW_CLEANING": {
          "TITLE": "Window Cleaning",
          "DESCRIPTION": "Clean all windows in a two-story house, inside and out"
        },
        "LAWN_MOWING": {
          "TITLE": "Lawn Mowing",
          "DESCRIPTION": "Regular lawn mowing for a 500 sqm garden"
        },
        "GRAPHIC_DESIGN": {
          "TITLE": "Graphic Design",
          "DESCRIPTION": "Design a logo and business cards for startup"
        },
        "HANDYMAN": {
          "TITLE": "Handyman",
          "DESCRIPTION": "Various small repairs around the house"
        }
      }
    },
    "LANDING": {
      "COMMUNITY_1": "Handyhand is a marketplace",
      "COMMUNITY_2": "With {{handyhanders}}+ verified and reviewed companies and individuals offering help for tasks of any kind.",
      "EARN": "Earn money with Handyhand",
      "FOOTER_DESC": "Handyhand is a Danish marketplace community where people can find help for tasks of any kind, connect with private handymen and local services, or perform flexible tasks and earn money.",
      "FOOTER_SLOGAN": "We focus on safety, trust, and transparency.",
      "FOOTER_COMPANY": "Company",
      "FOOTER_EXPLORE": "Explore",
      "HERO_USP_1": "customers",
      "HERO_USP_2": "tasks",
      "HERO_USP_3": "reviews",
      "LANG_SWITCH": "Switch language to ",
      "MEET": "Meet some Handyhanders",
      "META_TITLE": "Get tasks done in your home or earn money on Handyhand",
      "META_DESC": "Get tasks done in cleaning, pickup, carpentry, wall mounting for the home. Online job platform for small tasks, create a task and receive bids from private individuals today.",
      "OWN_BOSS": "Your very own boss",
      "OWN_BOSS_DESC": "Are you good with your hands, or maybe just a wizard at IT? maybe your next task is waiting on Handyhand.",
      "OWN_BOSS_USP_1": "Free access to thousands of tasks",
      "OWN_BOSS_USP_2": "No subscription or hidden fees",
      "OWN_BOSS_USP_3": "Earn extra income whenever you have time and desire",
      "SUB_TXT": "Moving, gardening, plumbing, painting, window cleaning and",
      "SUB_TXT_2": "much more.",
      "USP_MAIN_TITLE": "Why should I use Handyhand?",
      "USP_HERO_WOMAN_ALT": "Woman with phone",
      "USP_HERO_WOMAN_IMG_PATH": "private/lp/webp/lp_hero_imgs/happy_woman_with_phone.webp",
      "USP_1_DESC": "Only release payment when the task is completed to your satisfaction",
      "USP_2_DESC": "Pick the right person for the task based on real ratings and reviews from other users",
      "USP_3_DESC": "Covered by our damage compensation model, if there should ever be an incident. Read more about",
      "USP_1_TITLE": "Secure payment",
      "USP_3_LINK": "Damage compensation.",
      "USP_2_TITLE": "Verified reviews",
      "USP_3_TITLE": "Damage compensation",
      "USP_EASY": "Easy to use",
      "OR_ANYTHING": "… or anything else",
      "USP_JOB": "You can start looking for jobs near you right away. You can filter by location and categories and get notified when tasks you are interested in appear near you.",
      "WHY_PAY_TIT": "Quick and secure payment",
      "WHY_PAY_DESC": "We secure your payment even before you start the task, so you can be sure that the money is there when the task is completed.",
      "HH_PROFILE_IMG_ALT": "Handyhand profile picture",
      "HH_NAME_1": "Carsten",
      "HH_NAME_2": "Lise",
      "HH_NAME_3": "Gustav",
      "HH_TRUST": "Trust",
      "HH_DESC_1": "With 10 years of handyman experience, Carsten now also offers home improvements like custom shelves and smart solutions that add a personal touch.",
      "HH_DESC_2": "Lise has 7 years of cleaning experience and also helps with organizing – from closets and drawers to kids’ rooms, always bringing structure and order.",
      "HH_DESC_3": "Gustav is a garden expert who transforms outdoor spaces with landscape design, colorful flowerbeds, and decorative paths into personal retreats.",
      "HH_WHAT_OTHERS_SAY": "What others say about ",
      "HH_WHAT_OTHERS_SAY_1": "Very friendly and reliable. Can clearly recommend Carsten for handyman tasks. Thanks for the help!",
      "HH_WHAT_OTHERS_SAY_2": "Lise saved me from chaos when the kids had knocked everything over – she tidied up with a smile, and the children loved her.",
      "HH_WHAT_OTHERS_SAY_3": "Did a great job in the garden and has a great attitude. We will definitely use Gustav in the garden again.",
      "HH_TESTIMONIAL_1": "Very friendly and reliable. Can clearly recommend Carsten for handyman tasks. Thanks for the help!",
      "HH_TESTIMONIAL_2": "Amanda got our house in order and was caring and arrived on time. We will definitely use Amanda again.",
      "HH_TESTIMONIAL_3": "Did a great job in the garden and has a great attitude. We will definitely use Gustav in the garden again.",
      "HH_SPECIALITY_1": "Handyman, furniture assembly, moving help",
      "HH_SPECIALITY_2": "Cleaning, home help, furniture assembly",
      "HH_SPECIALITY_3": "Gardening, painting, dog walking",
      "HOW_1": "How does it work?",
      "HOW_2": "What do you need done?",
      "HOW_2_1": "Here you’ll find both professional tradespeople and skilled helpers, ready to get your task done.",
      "HOW_2_2": "See all categories",
      "HOW_4": "Review bids",
      "HOW_5": "Receive bids from skilled people and see their profiles",
      "HOW_6": "Get it done",
      "HOW_7": "Choose the right person for your task and get it done",
      "HOW_8": "Share your task",
      "HOW_9": "Create and describe your task. It's free to create",
      "HOW_10": "The video below shows how Handyhand can help you get your everyday tasks done.",
      "HOW_DESC": "Describe your task and get it solved online for everything at home",
      "HOW_ONLINE": "Post a task and get different bids and offers online",
      "POPULAR_CATEGORIES": "Categories",
      "PRICE_INDEX": "Price index",
      "PRICE_GUIDES": "Price guides",
      "SEE_VID": "See how",
      "HERO_IMG_ALT": "Marketplace for tasks in the home",
      "PAUSE_ROTATION": "Pause rotation",
      "RESUME_ROTATION": "Resume rotation",
      "STARS": "Stars",
      "TO_BUTTON": "Create task for free",
      "PP_BUTTON": "Earn money today",
      "COPYRIGHT": "Copyright Pinploy ApS. - 2025 Tordenskjoldsgade 14, 1055 KBH K.",
      "FAQ": {
        "FAQ_HEADER": "Questions and Answers",
        "FAQ_1_QUESTION": "What does it cost to use Handyhand?",
        "FAQ_1_ANSWER": "It is free to use Handyhand to find help for your tasks. The only thing you have to pay for is the help you find through the platform, which is often up to 70% cheaper than the craftsman's price. You will receive bids from both private individuals and companies. If you're not sure what you should pay for a task, you can choose the 'Receive bids' option, and our helpers will give their bids on what the task should cost. All you have to do is create your task, receive offers, and choose your helper. Your helper is paid through the system only when the task is finished.",
        "FAQ_2_QUESTION": "What kind of help can I find?",
        "FAQ_2_ANSWER": "You can find help for almost anything on Handyhand. Whether you need a handyman, carpenter, cleaning helper, plumber, gardener, dog walker, painter, bricklayer, or something completely different, you can find the right person for your task on Handyhand.",
        "FAQ_3_QUESTION": "How do you use Handyhand?",
        "FAQ_3_ANSWER": "It is very easy to use Handyhand. All you have to do is create a task by clicking on 'Create task'. Give a good description of the task you need solved, when the latest bids can be given, and where it is to be performed. You set a budget that is fair and fits the task, or choose to receive bids. Then all you have to do is sit back, receive bids, and choose your helper. It doesn't get any easier!",
        "FAQ_4_QUESTION": "How do you pay?",
        "FAQ_4_ANSWER": "Handyhand makes it easy and secure to pay for your task with HandyhandPay™. When you choose a helper through the platform, your payment is securely held in the system until the task is completed - and you decide when that is! Only when you have reported that the task is finished, the money is paid out to your helper. Should the task not be carried out for one reason or another, you can cancel the task and be refunded.",
        "FAQ_5_QUESTION": "I would like to perform tasks and earn money, can I do that?",
        "FAQ_5_ANSWER": "Yes! If you are a good handyman, a sharp painter, skilled furniture assembler, or something else entirely, it is super easy to find tasks near you. Find a task you want to perform, then ask questions to the task owner or give a bid on the task. Handyhand makes it easy to get small and medium-sized jobs online through our platform. Help people get tasks done at home and earn money today on small tasks. Start earning money today as a Handyhander!",
        "FAQ_6_QUESTION": "What about taxes?",
        "FAQ_6_ANSWER": "Handyhand sends receipts to both you and your helper, and makes it possible to keep track of your earnings on the platform, thereby making it easy to report to the tax authorities, which we strongly encourage all our helpers to do.",
        "FAQ_7_QUESTION": "Get help or contact Handyhand Support",
        "FAQ_7_ANSWER": "You can get help by visiting our support page at https://handyhand.dk/contact.",
        "FAQ_8_QUESTION": "Help center",
        "FAQ_8_ANSWER": "Handyhand has a FAQ where you can find answers to frequently asked questions. You can find our FAQ at https://handyhand.dk/help"
      },
      "LP1": {
        "TITLE_1": "Find help for",
        "ANYTHING": "anything",
        "GARDEN": "the garden",
        "HOME": "the home",
        "IT": "the computer",
        "MOVING": "the move",
        "CLEANING": "cleaning",
        "PARTY": "the party",
        "TITLE_2": "No-obligation bids from reviewed and trusted experts in minutes",
        "TITLE_2_1": "It takes less than 2 minutes and it's free!",
        "TITLE_2_2": "Share, Choose, Done!",
        "PLACEHOLDER": "I need to have...",
        "HERO_USP_1": "customers",
        "HERO_USP_2": "tasks",
        "HERO_USP_3": "reviews",
        "PAINTER": "painting",
        "CARPENTER": "carpentry",
        "ELECTRICIAN": "electrical work",
        "PLUMBING": "plumbing",
        "BRICKLAYER": "bricklaying",
        "FLOOR": "the floor",
        "FURNITURE_ASSEMBLY": "furniture assembly",
        "FURNITURE": "the furniture",
        "APPLIANCES": "appliances",
        "CARPORT": "the carport",
        "BIKE": "the bike",
        "HANDYMAN": "handywork",
        "EYEBROW": "Denmark's largest task platform",
        "SUBTITLE": "Describe your task, get offers, choose the right helper.",
        "TRUSTPILOT_ALT": "See our reviews on Trustpilot"
      },
      "SERVICE_OPTIONS": {
        "HEADLINE": "What do you need help with?",
        "HANDYMAN": "Handyman",
        "GARDENING": "Gardening",
        "CARPENTER": "Carpenter",
        "PLUMBING": "Plumbing",
        "PAINTER": "Painter",
        "WASTE_COLLECTION": "Waste Collection",
        "ELECTRICIAN": "Electrician",
        "TECHNICIAN": "IT Help",
        "MOVING_HELP": "Moving Help",
        "FURNITURE_ASSEMBLY": "Furniture Assembly",
        "CLEANING": "Cleaning",
        "WINDOW_CLEANING": "Window Cleaning",
        "HEDGE_TRIMMING": "Hedge Trimming"
      },
      "REVIEWS_TITLE": "See what others have had done",
      "REVIEWS_SUBTITLE": "More than {{tasks}} tasks have already been solved through Handyhand.",
      "REVIEWS_DONE_BY": "Done by",
      "REVIEWS_RATING_LABEL": "{{rating}} out of 5 stars"
    },
    "HOW_TO_GUIDE": {
      "META_TITLE": "2023 Do-It-Yourself Guides",
      "META_DESC": "Find all our do-it-yourself guides on different services here."
    },
    "HUB": {
      "SCHEMA": {
        "DESC": "Articles, tips and tricks, guides, and price estimates. "
      },
      "READING_TIME": "Reading time",
      "GUIDE_TITLE": "Guides",
      "TIPS_TITLE": "Tips and tricks within",
      "TIPS_DESC": "Find tips and tricks for everything at home here",
      "PRICE_GUIDE_TITLE": "Price guides within",
      "PRICE_DATA_TITLE": "Price data from tasks",
      "VERTICAL_TITLE": "Receive free bids within",
      "SUB_HUB_TITLE": "Other categories",
      "PRICE_DATA_DESC": "Price data over all kind of tasks from the Handyhand platform",
      "SYNTHETIC_PRICE_GUIDE_TITLE": "Illustrative price estimates",
      "SYNTHETIC_PRICE_GUIDE_DESC": "We have gathered some illustrative price estimates for you",
      "DEEPLINK_GUIDES": "Guides",
      "DEEPLINK_PRICE_GUIDES": "Price guides",
      "DEEPLINK_TIPS_TRICKS": "Tips & tricks",
      "DEEPLINK_SERVICES": "Services",
      "LOCAL_SERVICES_LINK": "See local services here",
      "MINI_SERVICES_LINK": "See mini services here"
    },
    "TIPS_INDEX": {
      "SUB_CATEGORIES_TITLE": "Tips by sub-category",
      "DIRECT_TIPS_TITLE": "Other tips in this category",
      "ALL_IN_PARENT": "See all tips in",
      "H1_PREFIX": "All tips in"
    },
    "MINI_SERVICES_INDEX": {
      "SUB_CATEGORIES_TITLE": "Mini services by sub-category",
      "DIRECT_SERVICES_TITLE": "Other mini services in this category",
      "ALL_IN_MAIN": "See all mini services in",
      "H1_PREFIX": "All mini services in",
      "META_DESCRIPTION": "See all our mini services in {{category}}. Find the right service for your needs."
    },
    "LOCAL_SERVICES_INDEX": {
      "H1_PREFIX": "All local companies within"
    },
    "INSPIRATION": {
      "META_TITLE": "- Shortcut for fast and cheap solution -",
      "DESC_H": "Private individuals offer affordable help for tasks related to ",
      "CREATE": ". Create your task and receive non-binding bids",
      "TITLE": "Here are the most popular task types on Handyhand, inspiration for the home",
      "DESC": "Overview list of the tasks most often sought help for on Handyhand. At HandyHand, you can find a range of the most popular tasks that have been carried out in the home. Our website is a great source of inspiration for those who want to update their home with new projects. You can find everything from minor repairs to extensive renovations that can give your home a whole new look. We have compiled a list of the most requested tasks so you can get an idea of what is possible in your own home. Browse our selection of tasks and get ideas on how to improve your home and make it more functional and beautiful.",
      "HELP": "Handyhanders offering help for tasks related to",
      "PREV": "Inspiration from previously created tasks about"
    },
    "DAMAGE_COMPENSATION": {
      "HEAD1": "Protection",
      "HEAD2": "Damage compensation",
      "HEAD3": "Covered by our damage compensation model",
      "USP1": "It's nice to be covered in case of an accident - that's why we have damage compensation available that helps you perform tasks with peace of mind.",
      "USP2": "Handyhand's damage compensation covers any property damage that could occur during the execution of a task at a third party while the task is underway.",
      "USP3": "Handyhand's damage compensation is provided in house - to make sure you are always covered.",
      "INFO": "Your task is covered",
      "HEADLINE": "Handyhand damage compensation",
      "SUB_HEADLINE_1": "We are here for you",
      "SUB_P_1": "When you get help to solve a task through Handyhand, you are automatically covered by our damage compensation.",
      "SUB_HEADLINE_2": "Strong damage compensation model",
      "SUB_P_2": "Our damage compensation gives you peace of mind when you get help through Handyhand.",
      "INTRO_HEAD_1": "Coverage",
      "INTRO_TEXT_1": "Handyhand's damage compensation covers up to {{maxAmount}} for any property damage that could occur during the execution of a task at a third party while the task is underway. This is in addition to any other insurance you or the service provider has.",
      "HERO_SUB": "When you get a task solved through Handyhand, you are automatically covered by our damage compensation – at no extra cost.",
      "CHIP_COVERAGE": "Coverage up to {{maxAmount}}",
      "CHIP_AUTOMATIC": "Automatically covered",
      "TOC_TITLE": "On this page",
      "META_TITLE": "Damage compensation – coverage up to {{maxAmount}}",
      "META_DESC": "Learn about Handyhand's damage compensation: what is covered, how to report a damage, and which limits and deadlines apply.",
      "TERMS": {
        "INTRO": {
          "P1": "When you book a task through the Handyhand platform, you may be covered by our damage compensation scheme under the terms below. The scheme is a limited, voluntary compensation from Handyhand. It is not insurance or a guarantee, and it does not change the fact that the agreement for the work is made directly between you and the service provider.",
          "P2": "Handyhand's damage compensation scheme can pay compensation of up to {{maxAmount}} per task for certain sudden and unexpected property damage that occurs while a task booked and paid for through Handyhand is being carried out. The scheme supplements any ordinary insurance held by the task owner and the Handyhander and is subject to the terms, limitations and exclusions set out below.",
          "P3": "\"Property damage\" means physical damage to movable property, fixtures, buildings or other tangible items. The scheme does not cover pure financial loss, business interruption, loss of earnings or other indirect losses."
        },
        "HOW_IT_WORKS": {
          "TITLE": "How does damage compensation work?",
          "P1": "You may be covered by the damage compensation scheme when the task is booked and paid for through Handyhand and the damage occurs while the work itself is being carried out.",
          "P2": "The scheme only applies during the periods when the work is actually being carried out. Damage that occurs after that is not covered, even if the task has not yet been marked as completed.",
          "P3": "The damage must be reported no later than 14 days after the task has been marked as completed or cancelled."
        },
        "COVERAGE": {
          "TITLE": "What does damage compensation cover?",
          "P1": "Handyhand's damage compensation applies to certain property damage caused directly by a sudden, one-off accident during the work.",
          "P2": "The scheme does not cover damage caused by defective workmanship, faulty installation, incorrect working methods, insufficient professional skill or failure to comply with applicable rules and instructions."
        },
        "LIMITS": {
          "TITLE": "Amount limits",
          "LEAD": "The following amount limits apply to the damage compensation scheme:",
          "ITEMS": {
            "MAXIMUM": "Maximum compensation: {{maxAmount}} per task.",
            "MINIMUM": "Damage below {{minAmount}} is not processed.",
            "DEDUCTIBLE": "A deduction of {{deductibleAmount}} is made from all damage compensation.",
            "DOCUMENTED_LOSS": "Compensation can never exceed the documented financial loss.",
            "INDIRECT_LOSS": "No compensation is paid for indirect losses or consequential damage."
          }
        },
        "COVERED_EXAMPLES": {
          "TITLE": "Examples of damage that may be covered:",
          "ITEMS": {
            "PAINT": "Paint spilled on the floor while painting walls.",
            "SHELF": "A shelf is dropped during installation and breaks.",
            "MOVING_BOX": "A moving box is dropped and its contents are damaged.",
            "WINDOW": "A window pane is broken while moving furniture in or out.",
            "BUILDING": "Damage to parts of a building, e.g. plaster, walls, door frames or floors, caused by a sudden accident while the task is being carried out."
          }
        },
        "NOT_COVERED": {
          "TITLE": "What is not covered by damage compensation?",
          "ITEMS": {
            "AUTHORISATION": "Damage that occurs if the service provider does not hold the required authorisations or permits for the work, e.g. wet-room or electrical work.",
            "TASK_DESCRIPTION": "Damage resulting from incorrect or misleading task descriptions on your part as the customer.",
            "INTENT": "Damage caused intentionally by the service provider.",
            "GROSS_NEGLIGENCE": "Damage resulting from gross negligence on your part. <em>Gross negligence refers to a significant departure from normal, responsible behaviour – for example ignoring obvious risks or continuing the work after being clearly asked to stop.</em>",
            "WORKMANSHIP": "Damage and losses caused by defective workmanship, faulty installation, incorrect working methods, insufficient professional skill or failure to comply with applicable rules and instructions.",
            "INDIRECT_LOSS": "Indirect losses, business interruption, derived financial losses or consequential damage arising as a result of the original damage."
          },
          "P1": "For tasks where the law requires authorisation or special approval, it is the customer's responsibility to make sure the service provider holds the necessary authorisation. Missing authorisation may mean that no damage compensation is paid."
        },
        "SETTLEMENT": {
          "TITLE": "Repair, replacement or financial compensation – what applies?",
          "P1": "Handyhand decides, based on a specific assessment, whether financial compensation is paid on the basis of repair or replacement. The assessment takes into account, among other things, whether repair is possible, the costs, and the age and condition of the item.",
          "P2": "Handyhand assesses each claim individually based on the documentation received. It is up to the customer to substantiate the extent, cause and value of the damage."
        },
        "PRIVATE_INSURANCE": {
          "TITLE": "Do I still need private insurance?",
          "P1": "Yes, we recommend that you keep your own private insurance, as the damage compensation scheme only covers selected damage related to the task and is subject to amount limits and exclusions.",
          "P2": "If damage occurs, it may also be relevant to report it to your own insurance and/or the service provider's insurance, depending on the situation. You can report the damage to Handyhand at the same time, and we will guide you on what documentation is typically needed for the scheme.",
          "P3": "We hope everything goes smoothly with the task you have booked! If you have questions about the damage compensation scheme or need help reporting damage, you are always welcome to contact us."
        },
        "HOW_TO_APPLY": {
          "TITLE": "How do I apply for damage compensation?",
          "P1": "<strong>Before you apply for damage compensation, the task must be either completed or cancelled on the Handyhand platform.</strong>",
          "P2": "Once the task is completed or cancelled, the damage must be reported as soon as possible using Handyhand's <a href=\"{{applicationUrl}}\">application form</a> and no later than 14 days after the task was completed or cancelled.",
          "P3": "<strong>Please note that if you complete the task, the payment is released and paid out to the service provider.</strong> Once the funds have been paid out, Handyhand cannot recover them from the service provider.",
          "P4": "If you believe damage has occurred, or that the task should not be completed, you should therefore not complete the task until the situation has been resolved. Instead, you can <a href=\"{{cancellationUrl}}\">request a cancellation</a> or contact Handyhand for help.",
          "P5": "If the cancellation is disputed and you cannot reach a compromise, you can read more about <a href=\"{{disputeUrl}}\">Handyhand's dispute process</a>. The dispute process can take up to 14 days. Handyhand cannot guarantee a resolution, but can help review the case and suggest a compromise.",
          "CHECKLIST": {
            "TITLE": "What to have ready when you apply",
            "LEAD": "So that we can process your claim as quickly and accurately as possible, you should have the following ready before you fill in the form:",
            "ITEMS": {
              "TASK": "Details of the relevant task, e.g. the task title or a link to the task.",
              "DESCRIPTION": "A short, specific description of what happened, when the damage occurred and how the damage relates to the work on the task.",
              "PHOTOS": "Photos or other documentation that clearly show the damage and its extent.",
              "COMMUNICATION": "Any communication with the service provider about the damage, if it helps clarify what happened.",
              "VALUE": "Documentation of the value of the item or the damage, e.g. a receipt, invoice, valuation or other relevant documentation.",
              "REPAIR_COST": "Documentation of repair or replacement costs, e.g. a quote, valuation or invoice.",
              "OWN_INSURANCE": "If the damage has been reported to your own insurance, you should also have the relevant documentation from it ready, e.g. the decision, the excess or other relevant information."
            },
            "NOTE_PROPERTY": "If the damage concerns real property or parts of a building, e.g. plaster, walls or floors, a tradesperson's quote or a professional assessment can often be used instead of an original purchase price.",
            "NOTE_REPAIR": "If the item can potentially be repaired, we may ask for a repair quote – or a professional assessment confirming that repair is not possible or not economically justifiable.",
            "OUTRO": "Handyhand assesses the case based on the documentation you submit. It is therefore important that you describe the damage as specifically as possible and attach the documentation that can substantiate the cause, extent and value of the damage."
          }
        },
        "REAL_CASES": {
          "TITLE": "Examples of real cases",
          "LEAD": "To make it easier to understand what we cover, we have collected a number of examples based on previous decisions. Remember that each case is assessed individually based on the documentation submitted.",
          "APPROVED": {
            "TITLE": "What we typically approve: Sudden accidents",
            "ITEMS": {
              "DROPPED": "Dropped items: A service provider drops a heavy item onto a hob, which shatters.",
              "HANDLING": "Damage during handling: A board or panel suddenly breaks because it tips over or is dropped during the work itself.",
              "ASSEMBLY": "Cosmetic accidents during assembly: New furniture gets deep scratches or scuffs because tools or parts slip during assembly.",
              "MOVING": "Moving damage: A piece of furniture is knocked or scuffed while being carried through a doorway or up a staircase."
            }
          },
          "REJECTED": {
            "TITLE": "What we typically reject: Poor workmanship or missing authorisation",
            "ITEMS": {
              "INSTALLATION": "Faulty installation and poor workmanship: A sink or tap is installed incorrectly, leading to a leak. This is considered defective workmanship, not an accident.",
              "FORESEEABLE": "Foreseeable consequences: Dust from sanding or sawing spreads through the house. This is a natural consequence of the work process and could have been avoided with protective covering.",
              "WEAR": "Old damage and corrosion: Pipe damage is discovered after cleaning, but technical investigations show that the damage is due to many years of corrosion and rust.",
              "METHOD": "Wrong method: Scratches or stains appear because the service provider used the wrong sanding method or the wrong cleaning product on a delicate surface.",
              "CONSEQUENTIAL": "Consequential damage from errors: A motor or machine breaks down because a repair was not carried out correctly. This is considered a consequence of defective workmanship and not a sudden accident during the work.",
              "ASBESTOS": "Working with asbestos without authorisation: Damage or contamination arising from work with asbestos is rejected if the service provider does not hold the legally required authorisation. It is your own responsibility as the customer to make sure the service provider can show valid proof of authorisation before the work begins."
            }
          },
          "NOTE_PARTIAL": "If damage is caused both by an accident that qualifies for cover and by circumstances not covered by the scheme, Handyhand may, based on a specific assessment, limit the compensation to the part of the damage that can be directly attributed to the qualifying accident."
        }
      }
    },
    "PRICE_GUIDE": {
      "PRICE_GUIDE": "Price Guide",
      "INDICATIVE_PRICES": "Indicative prices",
      "LOW": "Low",
      "MEDIUM": "Median",
      "HIGH": "High",
      "RELATED": "Related Articles",
      "META": "Price guides and estimates",
      "META_TITLE": "Handyhand Price Guides 2023",
      "META_DESC": "Find all our price guides on different services here. Get a bid online for help from inside the home to the house and garden.",
      "SIMILAR_TASKS": "Similar tasks checked",
      "AVERAGE_OFFERS": "Avg offers per task",
      "AVERAGE_PRICE": "Avg price of tasks",
      "SIMILAR_TASKS_TITLE": "Similar tasks",
      "AVG_OFFER_SIMILAR_TASK": "Avg offer",
      "OFFERS": "Offers",
      "LOCATION": "Location",
      "BUDGET": "Budget",
      "CREATED_AT": "Created at",
      "DESCRIPTION": "Description",
      "TASK_EXAMPLE": "Example from a real task",
      "TASK_EXAMPLE_DESC": "Here is an example of a real task that was solved on Handyhand,",
      "TASK_EXAMPLE_DESC_2": ". This is a great way to get an idea of what someone else paid for a similar task.",
      "CALCULATE_PRICE": "Try price calculator",
      "FROM_LOCATION": "From",
      "TO_LOCATION": "To",
      "DISTANCE": "Distance",
      "STAIRS": "Stairs",
      "ELEVATOR": "Elevator",
      "NO_STAIRS": "No stairs",
      "KM": "km",
      "ACCESSIBILITY": "Accessibility",
      "PEOPLE_WHO_COMPLETE": "People who complete tasks like this",
      "COMPLETED_TASKS": "completed tasks",
      "AVERAGE_RATING": "Average rating",
      "NO_RATING": "No rating yet",
      "SPECIALIZES_IN": "Specializes in",
      "RELATED_GUIDES": "Similair Price Guides",
      "AI_OVERVIEW": {
        "TITLE": "Price comparison based on Handyhand tasks",
        "DESCRIPTION": "With over 65.000 priceguides, we have the most comprehensive price guide on the internet. Find the price for your task in seconds.",
        "SEARCH_PLACEHOLDER": "Search our price estimates...",
        "SHOW_ALL": "Show all",
        "LOADING_GUIDES": "Loading price guides...",
        "SEE_ALL": "See all",
        "SERVICES": "services",
        "SEARCHING": "Searching"
      }
    },
    "SEO_CATEGORIES": {
      "TITLE": "Categories",
      "META_TITLE_JOBS": "Find jobs and tasks in all categories",
      "META_DESC_JOBS": "With our online platform, you can find new tasks in your field every day and earn money-",
      "META_TITLE_JOBS_LOCAL": "Find Local Jobs",
      "META_DESC_JOBS_LOCAL": "Find and apply for local jobs in your area with the Handyhand platform",
      "META_TITLE_VERTICAL": "Get your home tasks done",
      "META_DESC_VERTICAL": "Do you want private help? Get help from private individuals to solve your tasks in the house and garden ✓33% lower prices ✓Fast and easy",
      "META_TITLE_SERVICES_LOCAL": "Local Services",
      "META_DESC_SERVICES_LOCAL": "Find reliable local services and service providers in your area.",
      "DESC": "Whether you need help with repairs, installations, maintenance, or renovation, we have a category for you. Our categories span various areas such as plumbing, electricity, carpentry, painting, gardening, cleaning, moving, and much more. Whether you have a small or large project, you can find a category that suits your needs.",
      "EARN_H1": "Find freelance jobs and tasks - Earn money today",
      "EARN_SUB": "Handyhand is Denmark's best job marketplace for all kinds of jobs, from handymen to cleaning assistants to gardeners. Sign up now and earn money!"
    },
    "TIPS": {
      "BROWSER_TITLE": "Tips & tricks | Handyhand",
      "TITLE": "Find tips and tricks for everything in the home here",
      "TIPS": "Tips and tricks for all your projects",
      "SEARCH": "Search among 6000+ different tips here..."
    },
    "AI_PRICE_GUIDES_INDEX": {
      "H1_PREFIX": "Price data guides for",
      "INTRO_PART_1": "Find a detailed price overview for tasks in",
      "INTRO_PART_2": ", to help you estimate costs and make informed decisions based on data from our platform.",
      "LOADING": "Loading price guides...",
      "EMPTY": "No price data guides found in this category.",
      "BREADCRUMB_INDEX": "Price data guides index",
      "META_TITLE_PREFIX": "Price data for",
      "META_DESC_PREFIX": "Find task data for",
      "META_DESC_SUFFIX": " to help you estimate costs and make informed decisions."
    },
    "AI_PRICE_DATA_OVERVIEW": {
      "BREADCRUMB": "Price data",
      "META_TITLE": "Price data on tasks within handyman, gardening and {{tasks}}+ different tasks",
      "META_DESC": "See price data from tasks that tradespeople and handymen have completed on Handyhand's marketplace, e.g. carpenters, bricklayers, "
    },
    "PRESS_ROOM": {
      "INTRO": "The Handyhand press team helps journalists and others who need interviews, statistics, background information, photos and more.",
      "IMAGE_SECTION_WORKERS": "Photos of people doing work with Handyhand",
      "IMAGE_SECTION_TEAM": "Photos of the Handyhand team",
      "IMAGE_SECTION_PLATFORM": "Photos from the platform"
    },
    "EARNINGS_CALCULATOR_IMAGES": {
      "FEMALE_HANDYMAN": "female handyman",
      "TOOL_ICON": "tools icon",
      "BOY_CLEANING": "boy cleaning",
      "CLEANING_ICON": "cleaning icon",
      "GARDENER": "gardener"
    },
    "HOW_IT_WORKS_PAGE": {
      "HERO_ALT": "handyman marketplace sharing economy platform find tasks online in Denmark"
    },
    "PRIVACY_POLICY": {
      "ADDRESS_LINE": "Copenhagen K 1055",
      "COOKIE_SETTINGS_BUTTON": "Change cookie settings",
      "COOKIE_SETTINGS_UNAVAILABLE": "The cookie banner could not be opened. If you use an ad blocker or a privacy extension, allow this site and try again, or clear your cookies for this site and reload the page: the banner is shown again on your next visit."
    },
    "HANDYHANDER_LANDING": {
      "ALT_EARN": "platform earn money",
      "ALT_CARPENTER": "Handyhander carpenter"
    },
    "LANDING_TASK_EXAMPLES": {
      "OWNER_ALT": "Task owner for completed tasks online"
    },
    "ACCOUNT_DELETION": {
      "TITLE": "Account Deletion",
      "INTRO_TEXT": "To delete your Handyhand account, follow the steps below:",
      "STEP_1": "Log in to the account you want to delete",
      "STEP_2": "Click the button in the top right corner with your name and profile picture",
      "STEP_3": "Click on \"Account Settings\"",
      "STEP_4": "Scroll all the way down to the bottom of the page",
      "STEP_5": "Click on \"Delete Profile\"",
      "STEP_6": "Confirm the deletion by clicking on \"Yes\""
    },
    "VERTICAL": {
      "AVG_PRICE": "Average price of ",
      "FLEX_PRICE": "Flexible price",
      "BEST_OFF": "Choose the bid that suits you best!",
      "REVIEW_TITLE": "Average reviews of",
      "REVIEW_SUB": "Based on",
      "REVIEWS": "Reviews",
      "LOC_EXPERT": "Local experts",
      "SELECT_EXPERT": "Choose a local expert wherever you are in Denmark.",
      "MORE_TASKS": "See more tasks",
      "OFFER_NOW": "Get offers now",
      "OFFER_NOW_COMPANY": "Få bud fra lignende virksomheder",
      "OFFER_NO_TIME": "Bids in no time",
      "REC_OFFER": "Receive bids to do your task in no time!",
      "DESC_TASK_2": "Fill a short form and receive offers from private and companies ",
      "TASKS_CAT": "Find tasks within the category",
      "EARN_H1": "Find freelance jobs and tasks - Earn money today",
      "TIME": "It only takes 2 minutes, and then it's free",
      "TIME_2": "It only takes 2 minutes, and then it's free",
      "TRUE_REVIEWS": "Genuine reviews",
      "RELATED_SERV": "Related Services",
      "REVIEW_SELF": "Rate yourself - all tasks get a review!",
      "EARN_SUB": "Handyhand is Denmark's best job marketplace for all kinds of jobs, from handyman to cleaning assistants to gardeners. Sign up now and earn money!",
      "SEARCH_JOB": "Search for work",
      "JOB_TASK_AROUND": "See what tasks people want to get done near you...",
      "FIND_JOBS": "Find jobs within",
      "FIND_JOBS_2": "category. Paid work with tasks within",
      "MIT_ID": "Mit ID verified",
      "FACEBOOK": "Facebook verified",
      "DIGITAL_ID": "Digital ID verified",
      "BANK": "Bank verified",
      "MOBILE": "Mobile verified",
      "COMPANY": "Company verified",
      "TOP_STAR_REVIEW": "10+ five-star reviews",
      "BADGE_HEADER": "Verifications",
      "BADGES": {
        "WHAT_ARE_BADGES": "What are verifications?",
        "BADGES_DESCRIPTION": "Verifications are shown when certain ID documents and qualifications are verified. It's an important feature that helps continue building trust in our community.",
        "READ_MORE": "Read more about verifications",
        "HERE": "here",
        "MIT_ID_DESCRIPTION": "This verification indicates that an individual has verified their identity using MitID. MitID is Denmark's digital signature solution, providing secure authentication and digital signing capabilities. By verifying with MitID, users demonstrate their official identity and gain access to secure digital services.",
        "BANK_DESCRIPTION": "This verification indicates that an individual's bank account has been verified. Bank verification ensures secure financial transactions and adds an extra layer of trust to the platform. The verification process confirms that the user has legitimate access to the specified bank account.",
        "MOBILE_DESCRIPTION": "This verification indicates that an individual's mobile number has been verified. By confirming their ownership of the mobile number, they are ensuring a secure and reliable connection with our platform. The verification process is simple and straightforward. We send an SMS verification code to the member's mobile number to confirm its authenticity. This ensures that the number is indeed owned by the member and adds an extra layer of security to their account.",
        "COMPANY_DESCRIPTION": "This verification indicates that a company has been verified on our platform. Company verification ensures that the business is legitimate and registered, providing users with confidence that they are working with a verified business entity. The verification process includes checking business registration, contact information, and other relevant business details.",
        "TOP_STAR_REVIEW_DESCRIPTION": "This verification indicates that a user has received 10 or more 5-star verified reviews on their profile. This achievement demonstrates exceptional service quality and reliability, showing that multiple customers have had consistently positive experiences. Users with this badge have proven their ability to deliver high-quality work and maintain customer satisfaction."
      },
      "PRICE_SUGGESTER_TITLE": "Price Calculator",
      "PRICE_SUGGESTER_DESC": "Describe your task and receive an online price estimate in under 10 seconds",
      "OR": "Or",
      "WHY": {
        "1": "Why hire a",
        "2": "with Handyhand?",
        "EASE": "Handyhand makes it easy to find a",
        "WITHIN_CAT": "to help with your task within the category",
        "OTHER_USERS": "Other users from",
        "FOUND_LABOUR": "for example, found a skilled and affordable",
        "HELP": "to assist with tasks like:",
        "USP_1": "With Handyhand, you can easily find help from the best and most cost-effective",
        "IN_ZIP": "in postal code:",
        "PRICE_IN_CAT": "The price of tasks within the category",
        "PRICE_RES": "can vary according to your needs. However, most tasks in this category usually receive non-binding bids in the price range"
      },
      "MINI_VERTICAL": {
        "STATS": {
          "TITLE": "Statistics",
          "TASKS_COMPLETED": "Tasks completed this year",
          "AVERAGE_OFFERS": "Average offers per task",
          "AVERAGE_PRICE": "Average price of tasks",
          "FOOTER": "Statistics from the latest tasks on Handyhand over the last 4 years."
        }
      }
    },
    "NOT_FOUND": {
      "TITLE": "The page was not found",
      "LINKS_HEADER": "Find what you're looking for"
    }
  },
  "TOAST_MESSAGES": {
    "WARNING": {
      "TITLE": "Your task must have a title",
      "DESC": "Your task must have a description of at least 25 characters"
    }
  },
  "TOOLS": {
    "PRICE_SUGGESTER": {
      "CALC_PRICE": "Calculate price estimate",
      "CALC_ESTIMATE": "Calculating estimate",
      "HEADER": "Price Calculator",
      "INTRO_DESC": "Describe your task and receive an online price estimate in under 10 seconds",
      "ESTIMATE": "Estimate",
      "MIN": "Min. 25 characters",
      "INTRO": "Tasks others got done with a similar budget",
      "ONLY": "*Only on Handyhand",
      "PAY": "Paid:",
      "DESC": "DESCRIPTION",
      "MORE_RES": "Show more results",
      "TASK_COMP": "had this task completed",
      "USP_1": "Based on {{tasks}}+ tasks",
      "USP_2": "Uses AI to calculate price",
      "USP_3": "Matches with real tasks",
      "TITLE_LABEL": "Task title",
      "DESCRIPTION_LABEL": "Describe your task",
      "TITLE_PREFIX": "Task title, e.g. ",
      "TITLE": "Task title, e.g., Help moving a sofa",
      "DESCRIPTION": "Be as precise in your description as possible",
      "STEP_1": "Describe your task",
      "STEP_2": "Tell us where and when",
      "STEP_3": "Receive an online estimate in seconds",
      "TIPS_TITLE": "Tips to describe your task",
      "RELOAD_TIPS": "Load more tips",
      "LOADING_TIPS": "Loading tips...",
      "RELOAD_TIPS_TOOLTIP": "Update your description to see new tips"
    }
  },
  "PLACEHOLDERS": {
    "TO": "to",
    "I_CHAR": "in",
    "I": "Table of Contents",
    "REL_ART": "Explore more Articles in the category:",
    "REVIEW": "Latest Review",
    "VERIF": "Verifications",
    "SIM_TASKS": "Similar tasks within: ",
    "STARS": "stars"
  },
  "FOOTER": {
    "LINK_APP": "App",
    "LINK_BLOG": "Blog",
    "LINK_UPDATES": "Updates",
    "FREELANCE_CALCULATOR": "Freelance earnings calculator",
    "HEAD_CAT_LINKS": {
      "HANDYMAN": {
        "LABEL": "Handyman"
      },
      "GARDENING": {
        "LABEL": "Gardener"
      },
      "MOVING": {
        "LABEL": "Mover"
      },
      "CLEANING": {
        "LABEL": "Cleaning"
      },
      "WASTE": {
        "LABEL": "Waste collection"
      },
      "FURNITURE": {
        "LABEL": "Furniture assembly"
      },
      "ALL_CATEGORIES": {
        "LABEL": "All categories"
      }
    }
  },
  "SEO": {
    "SCHEMA": {
      "BREADCRUMB_HOME": "Home",
      "GUIDES_HUB_LABEL": "Guides",
      "TIPS_INDEX_NAME": "Tips index",
      "LOCAL_SERVICES_INDEX_NAME": "Local services index",
      "MINI_SERVICES_INDEX_NAME": "Mini services index",
      "INSPIRATION_INDEX_NAME": "Inspiration",
      "TIPS_BREADCRUMB": "Tips",
      "RECYCLING_BREADCRUMB_ROOT": "Waste & recycling",
      "RECYCLING_INDEX_TYPE_CENTERS": "Recycling centers",
      "RECYCLING_INDEX_TYPE_GARDEN": "Garden waste",
      "RECYCLING_INDEX_TYPE_OVERVIEW": "Recycling overview",
      "RECYCLING_INDEX_TYPE_BULK": "Bulk waste",
      "PRICE_GUIDE_MIDDLE_PRICE": "Middle price",
      "SERVICE_SUFFIX_IN_CITY": " in {{place}}",
      "SERVICE_SUFFIX_IN_REGION": " in {{place}}",
      "DEFAULT_ARTICLE_AUTHOR": "Handyhand",
      "WRITTEN_BY": "Written by",
      "LANDING_CONTACT_TYPE": "Customer service",
      "LANDING_AVAILABLE_LANGUAGES": ["Danish", "English"]
    },
    "PRICE_GUIDE_ARTICLE": {
      "EDITOR_SUFFIX": " article",
      "GENRE": "Price estimates and guides",
      "KEYWORDS": "{{category}} help and price guide 2024, online offers, get an estimate",
      "DESCRIPTION": "How much does {{category}} cost — estimates and a guide to hiring someone for your home? Our price guide breaks down prices for different {{category}} services."
    }
  },
  "GUIDES": {
    "AI_PRICE_GUIDE": {
      "OFFER_NAME": "{{name}} submitted bid no. {{n}}"
    }
  },
  "STATIC_DATA": {
    "REGIONS": {
      "aarhus": "Aarhus",
      "odense": "Odense",
      "storkoebenhavn": "Greater Copenhagen",
      "nordsjaelland": "North Zealand",
      "bornholm": "Bornholm",
      "vestsjaelland": "West Zealand",
      "sydsjaelland-og-oeer": "South Zealand and islands",
      "fyn": "Funen",
      "soenderjylland": "Southern Jutland",
      "midtvestjylland": "Central / West Jutland",
      "nordjylland": "North Jutland",
      "oestjylland": "East Jutland",
      "drenthe": "Drenthe",
      "friesland": "Friesland",
      "guelders": "Gelderland",
      "groningen": "Groningen",
      "limburg": "Limburg",
      "south-holland": "South Holland",
      "overijssel": "Overijssel",
      "flevoland": "Flevoland",
      "north-holland": "North Holland",
      "utrecht": "Utrecht",
      "zeeland": "Zeeland",
      "north-brabant": "North Brabant"
    }
  },
  "TERMS_AND_CONDITIONS": {
    "SECTIONS": {
      "18": {
        "READ_MORE": "Read more here about when this compensation can and cannot be used"
      }
    }
  }
}
